<template>
  <v-flex xs12 class="text-xs-left">
    <div
      class="d-inline-flex justify-content-start align-center cursor-pointer font-weight-bold"
      @click="backSimulator()"
    >
      <v-icon>mdi mdi-chevron-left</v-icon>
      Todos os simuladores
    </div>
  </v-flex>
</template>

<script>
try {
  var _base = require("@/page/_base.vue").default;
} catch (err) {
  var _base = require("@/framework/page/_base.vue").default;
}

export default {
  extends: _base,
  name: "BackSimulator",
  data() {
    return {};
  },
  methods: {
    backSimulator() {
      window.open("#/simuladores", "_self");
    },
  },
};
</script>

<style scoped></style>
